import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cdabe818"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "signup-container" };
const _hoisted_2 = { class: "social-signup-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    const _component_FriedH2 = _resolveComponent("FriedH2");
    const _component_GoogleIcon = _resolveComponent("GoogleIcon");
    const _component_FriedButton = _resolveComponent("FriedButton");
    const _component_LinkedInIcon = _resolveComponent("LinkedInIcon");
    const _component_FriedLink = _resolveComponent("FriedLink");
    const _component_i18n_t = _resolveComponent("i18n-t");
    const _component_FriedMessage = _resolveComponent("FriedMessage");
    const _component_FriedInput = _resolveComponent("FriedInput");
    const _component_LoginSignupContainer = _resolveComponent("LoginSignupContainer");
    const _directive_autofocus = _resolveDirective("autofocus");
    return (_openBlock(), _createBlock(_component_LoginSignupContainer, { "hide-image": _ctx.isModal }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(_component_FriedParagraph, { class: "branding" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('create-account')), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_FriedH2, { class: "signup-title branding" }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.title)), 1)
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_FriedButton, {
                        "data-external": "sign-up-with-google-button",
                        class: "identity-provider-btn margin-bottom",
                        "button-type": _ctx.ButtonType.Tertiary,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.handleProviderSignup(_ctx.IdentityProvider.Google)))
                    }, {
                        leftIcon: _withCtx(() => [
                            _createVNode(_component_GoogleIcon, { class: "icon" })
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sign-up-with-google')), 1)
                        ]),
                        _: 1
                    }, 8, ["button-type"]),
                    _createVNode(_component_FriedButton, {
                        class: "identity-provider-btn",
                        "button-type": _ctx.ButtonType.Tertiary,
                        "data-external": "sign-up-with-linked-button",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.handleProviderSignup(_ctx.IdentityProvider.LinkedIn)))
                    }, {
                        leftIcon: _withCtx(() => [
                            _createVNode(_component_LinkedInIcon, { class: "icon" })
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sign-up-with-linkedin')), 1)
                        ]),
                        _: 1
                    }, 8, ["button-type"])
                ]),
                _createVNode(_component_FriedParagraph, { class: "or-divider" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('or')), 1)
                    ]),
                    _: 1
                }),
                (_ctx.error)
                    ? (_openBlock(), _createBlock(_component_FriedMessage, {
                        key: 0,
                        class: "error",
                        title: _ctx.$t(_ctx.error.title),
                        type: _ctx.MessageType.Error
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_i18n_t, {
                                keypath: _ctx.error.description
                            }, {
                                contactSupportLink: _withCtx(() => [
                                    _createVNode(_component_FriedLink, {
                                        class: "contact-support",
                                        normal: true,
                                        href: "http://help.getaccept.com/",
                                        target: "_blank"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('contact-support')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                didYouMeanLink: _withCtx(() => [
                                    _createVNode(_component_FriedLink, {
                                        normal: true,
                                        onClick: _ctx.handleDidYouMeanClick
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.didYouMean), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["onClick"])
                                ]),
                                _: 1
                            }, 8, ["keypath"])
                        ]),
                        _: 1
                    }, 8, ["title", "type"]))
                    : _createCommentVNode("", true),
                _createElementVNode("form", {
                    id: "signup-form",
                    ref: "signupFormRef",
                    "data-external": "signup-form",
                    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                }, [
                    _withDirectives(_createVNode(_component_FriedInput, {
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.email) = $event)),
                        modelModifiers: { trim: true },
                        autocomplete: "user-email",
                        label: _ctx.$t('work-email'),
                        class: "signup-input",
                        "error-message": _ctx.emailValidation,
                        "data-external": "signup-email-input"
                    }, null, 8, ["modelValue", "label", "error-message"]), [
                        [_directive_autofocus]
                    ]),
                    _createVNode(_component_FriedButton, {
                        type: "submit",
                        disabled: !_ctx.email,
                        loading: _ctx.loading,
                        class: "signup-button",
                        "button-type": _ctx.ButtonType.Branding,
                        "data-external": "signup-submit-button"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.buttonText)), 1)
                        ]),
                        _: 1
                    }, 8, ["disabled", "loading", "button-type"])
                ], 544),
                _createVNode(_component_FriedParagraph, {
                    class: "terms",
                    size: _ctx.ParagraphSize.Small
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_i18n_t, { keypath: "agree-to-terms-and-conditions_v2" }, {
                            termsConditionLink: _withCtx(() => [
                                _createVNode(_component_FriedLink, {
                                    class: "bold",
                                    href: "https://www.getaccept.com/terms-and-conditions",
                                    target: "_blank"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('terms-and-condition')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            privacyPolicyLink: _withCtx(() => [
                                _createVNode(_component_FriedLink, {
                                    class: "bold",
                                    href: "https://www.getaccept.com/privacy-policy",
                                    target: "_blank"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('privacy-policy')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["size"]),
                _createVNode(_component_FriedParagraph, { class: "sign-in-link" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('already-have-an-account')) + " ", 1),
                        _createVNode(_component_FriedLink, {
                            class: "bold",
                            onClick: _ctx.redirectToLogin
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('sign-in')), 1)
                            ]),
                            _: 1
                        }, 8, ["onClick"])
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }, 8, ["hide-image"]));
}
